import { QueryList } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EmailCardComponent } from 'src/app/components/email-card/email-card.component';
import { ISelectOption, ISelectOptionApi } from 'src/app/interfaces/components/select.interface';
import {
  IAddress,
  IEmail,
  IPaymentMethod,
  IPersonRelation,
  ITelephoneContact,
} from 'src/app/interfaces/person/person.interface';
import { ContactsCardComponent } from '../../person/person-form/contacts-card/contacts-card.component';
import { FinancialInformationCardComponent } from '../../person/person-form/financial-information-card/financial-information-card.component';

export function mapEnterprisesToSelectOptions(items: ISelectOptionApi[]): ISelectOption[] {
  return items.map((item) => ({
    value: item.id,
    label: item.name,
  }));
}

export function createContactsForm(fb: FormBuilder, contact?: ITelephoneContact): FormGroup {
  return fb.group({
    id: [contact?.id ?? null],
    type: [contact?.type ?? '', Validators.required],
    name: [contact?.name ?? '', Validators.required],
    surName: [contact?.surname ?? '', Validators.required],
    telephone: [contact?.telephone ?? '', Validators.required],
    isMain: [contact?.isMain ?? false],
  });
}

export function createEmailForm(
  fb: FormBuilder,
  email?: IEmail,
  initialValue = false
): FormGroup {
  return fb.group({
    id: [email?.id ?? null],
    email: [email?.email ?? '', [Validators.required, Validators.email]],
    isMain: [email?.isMain ?? false],
    initialValue: [initialValue],
  });
}

export function createAddressForm(fb: FormBuilder, address?: IAddress): FormGroup {
  return fb.group({
    id: [address?.id ?? null],
    addressType: [address?.addressType ?? '', Validators.required],
    zipCode: [address?.zipCode ?? '', Validators.required],
    state: [address?.state ?? '', Validators.required],
    city: [address?.city ?? '', Validators.required],
    street: [address?.street ?? '', Validators.required],
    neighborhood: [address?.neighborhood ?? '', Validators.required],
    number: [address?.number ?? '', Validators.required],
    complement: [address?.complement ?? ''],
  });
}

export function createPaymentMethodsForm(fb: FormBuilder, paymentMethod?: IPaymentMethod): FormGroup {
  return fb.group({
    id: [paymentMethod?.id ?? null],
    paymentMethodId: [paymentMethod?.paymentMethodId ?? '', [Validators.required]],
    isMain: [paymentMethod?.isMain ?? false],
  });
}

export function createRelationForm(fb: FormBuilder, relation?: IPersonRelation): FormGroup {
  return fb.group({
    sourceId: [relation?.sourceId ?? '', Validators.required],
    sourceName: [relation?.sourceName ?? ''],
    relationTypes: [relation?.relationTypes ?? [], Validators.required],
  });
}

export function validateIsMainEmail(emailCardComponents: QueryList<EmailCardComponent>) {
  return emailCardComponents.some(component => {
    return component.control().get('isMain')?.value === true;
  });
}

export function validateIsMainTelephone(contactsCardComponents: QueryList<ContactsCardComponent>) {
  return contactsCardComponents.some(component => {
    return component.control().get('isMain')?.value === true;
  });
}

export function validateIsMainPaymentMethod(financialInformationCardComponents: QueryList<FinancialInformationCardComponent>) {
  return financialInformationCardComponents.some(component => {
    return component.control().get('isMain')?.value === true;
  });
}

export function handleDocumentFunction(event: string, form: FormGroup) {
  const documentTypeControl = form.get('documentType');
  const taxFrameworkControl = form.get('taxFramework');
  const enterpriseTypeControl = form.get('enterpriseType');

 if (event.length === 14) {
  documentTypeControl?.setValue('PF');
  taxFrameworkControl?.setValue('PhysicalPerson');
  enterpriseTypeControl?.setValue('PhysicalPerson');

  taxFrameworkControl?.disable();
  enterpriseTypeControl?.disable();


 } else {
  documentTypeControl?.setValue('PJ');

  taxFrameworkControl?.enable();
  enterpriseTypeControl?.enable();
 }

  documentTypeControl?.updateValueAndValidity();
  taxFrameworkControl?.updateValueAndValidity();
  enterpriseTypeControl?.updateValueAndValidity();

  handleIcmsTaxpayerFunction(form);
}

export function handleIcmsTaxpayerFunction(form: FormGroup) {
  const icmsTaxpayerControl = form.get('icmsTaxpayer');
  const stateRegistrationControl = form.get('stateRegistrationId');
  const isPhysicalPerson = form.get('documentType')?.value === 'PF';
  const icmsTaxpayer = icmsTaxpayerControl?.value;

  if (isPhysicalPerson) {
    icmsTaxpayerControl?.setValue('NonTaxpayer', { emitEvent: false });
    icmsTaxpayerControl?.disable({ emitEvent: false });
  } else {
    icmsTaxpayerControl?.enable({ emitEvent: false });
  }

  if (!isPhysicalPerson && (icmsTaxpayer === 'ExemptFromRegistration' || icmsTaxpayer === 'NonTaxpayer')) {
    stateRegistrationControl?.setValue('', { emitEvent: false });
    stateRegistrationControl?.disable({ emitEvent: false });
  } else {
    stateRegistrationControl?.enable({ emitEvent: false });
  }

  if (!isPhysicalPerson && icmsTaxpayer === 'Taxpayer') {
    stateRegistrationControl?.addValidators(Validators.required);
  } else {
    stateRegistrationControl?.removeValidators(Validators.required);
  }

  stateRegistrationControl?.updateValueAndValidity({ emitEvent: false });
}
